import React from 'react';

const WithRequired = (Component, requiredFields) => {
  return (props) => {
    return <Component {...props} requiredFields={requiredFields} />;
  };
};

export default WithRequired;
